<div class="min-h-screen flex flex-col">
  <app-navbar class="shrink-0"></app-navbar>

  <main class="w-full flex-1 min-h-0">
    <router-outlet></router-outlet>
  </main>
  <app-footer *ngIf="!hideFooter" class="shrink-0"></app-footer>
</div>
<p-toast [life]="4000" position="top-right" styleClass="z-[10000]"></p-toast>